/*----------------------------------
- LANDING: IDLE SCHEDULING
----------------------------------*/

/**
 * @docs docs/features/website-seo-performance
 */

/**
 * Runs `callback` once the page has loaded and the main thread is idle, `timeoutMs` at the
 * latest after that. The one scheduler behind everything that has no business before the
 * first paint, today the analytics SDK. Measured on the production phone Home, that SDK
 * plus the visitor fingerprint and bot check the site loaded until 2026-09-18 held the main
 * thread for about 700 ms before the hero was painted.
 */
export const runWhenIdleAfterLoad = (callback: () => void, timeoutMs: number): void => {
    if (typeof window === 'undefined') return;

    const start = () => {
        if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(() => callback(), { timeout: timeoutMs });
        } else {
            window.setTimeout(callback, timeoutMs);
        }
    };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
};
